/*
 * @Author: your name
 * @Date: 2021-12-06 09:12:00
 * @LastEditTime: 2021-12-06 11:45:02
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\views\finished-project\approval-profits\approvalProfits.routing.ts
 */
export const ApprovalProfitsRouting = [
    {
      path: "/finished-project/approval-profits/list",
      name: "approval-profits-list",
      meta: { title: "竣工决算" },
      component: () => import("@/views/finished-project/approval-profits/list/index.vue"),
    },
    {
      hidden: true,
      path: "/finished-project/approval-profits/create",
      name: "approval-profits-create",
      meta: { title: "新建竣工决算",comName:"finishedProjectApprovalProfitsFormCreate" },
      component: () => import("@/views/finished-project/approval-profits/form-create/index.vue"),
    },
		{
      hidden: true,
      path: "/finished-project/approval-profits/edit/:id",
      name: "approval-profits-edit",
      meta: { title: "编辑竣工决算",comName:"finishedProjectApprovalProfitsFormCreate" },
      component: () => import("@/views/finished-project/approval-profits/form-create/index.vue"),
    },
		{
      hidden: true,
      path: "/finished-project/approval-profits/detail/:id",
      name: "approval-profits-detail",
      meta: { title: "竣工决算详情" },
      component: () => import("@/views/finished-project/approval-profits/form-detail/index.vue"),
    },
		{
      hidden: true,
      path: "/finished-project/approval-profits/flowPrint/:id",
      name: "finished-project-approval-profits-flow-print",
      meta: { title: "打印详情" },
      component: () =>
        import(
          /* webpackChunkName: "finished-project-approval-profits" */ "@/views/finished-project/approval-profits/flow-print/index.vue"
        ),
    }
  ];
  